import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import QuickStartSection from './components/QuickStartSection';
import CommunitySection from './components/CommunitySection';
import CTASection from './components/CTASection';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://openclaw.cc';

  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'OpenClaw 中文文档',
      url: siteUrl,
      description: '真正能做事的 AI 智能体框架，支持企业微信、飞书、钉钉、微信等多消息渠道接入',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'OpenClaw',
      url: siteUrl,
      logo: `${siteUrl}/lobster.svg`,
      description: 'AI 智能体框架开发团队',
      sameAs: [],
    },
  ];

  return (
    <div className="min-h-screen bg-slate-900">
      <SEOHead
        title="OpenClaw 中文文档 | 个人 AI 助手 · 任意平台 · 龙虾之道 🦞"
        description="OpenClaw 官方中文文档 — 真正能做事的 AI 智能体框架，支持企业微信、飞书、钉钉、微信等多消息渠道接入，打造您的专属 AI 助手平台。"
        keywords="OpenClaw, AI智能体, 消息渠道, 企业微信, 飞书, 钉钉, AI助手, 智能体框架"
        canonical={siteUrl}
        jsonLd={jsonLd}
      />
      <Navbar transparent={true} />
      <Hero />
      <FeaturesSection />
      <QuickStartSection />
      <CommunitySection />
      <CTASection />
      <Footer />
    </div>
  );
}